// SelectedCardsSheet — zeigt die markierten Karten des Auswahl-Modus (Tipp auf den
// Zähler in der Kopfzeile). Ein Tipp auf eine Zeile demarkiert die Karte.
import React from 'react';
import { X } from 'lucide-react';
import BottomSheet from '../../../../ui/BottomSheet';
import List from '../../../../ui/List';

export default function SelectedCardsSheet({ open, onOpenChange, cards = [], onRemoveFromSelection }) {
  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} title={`${cards.length} ausgewählt`}>
      <List>
        {cards.map((card) => {
          const cardId = card.scryfallId || card.id;
          const quantity = Number(card.quantity) > 0 ? Number(card.quantity) : 1;
          return (
            <List.Item key={cardId} onClick={() => onRemoveFromSelection?.(cardId)}>
              <List.Main>
                <List.Name>{card.name}</List.Name>
                {quantity > 1 && <List.Meta>×{quantity}</List.Meta>}
              </List.Main>
              <List.Actions>
                {/* Sichtbarer Hinweis, was der Zeilen-Tipp tut — derselbe Handler.
                    Die Actions-Spalte liegt neben dem Zeilen-Knopf (ui/List), der
                    Klick löst die Zeile also nicht zusätzlich aus. */}
                <button
                  type="button"
                  className="btn-icon"
                  aria-label={`${card.name} abwählen`}
                  onClick={() => onRemoveFromSelection?.(cardId)}
                >
                  <X aria-hidden />
                </button>
              </List.Actions>
            </List.Item>
          );
        })}
      </List>
    </BottomSheet>
  );
}
